export const getFormName = (formType?: string) => {
  if (formType === "meeting") return "Mazda_meeting_form"
  if (formType === "financing") return "Mazda_funding_form"
  if (formType === "test-drive") return "Mazda_test_drive_form"
  if (formType === "newsletter") return "Mazda_newsletter_form"
  return "Mazda_meeting_form"
}
